const { instance } = require('./url')

async function getAllScheduleTemplates() {
    return await instance.get('/schedule_template/all')
}

async function updateScheduleTemplate(template) {
    return await instance.put('/schedule_template/' + template.id, { template })
}

async function insertScheduleTemplate(template) {
    return await instance.post('/schedule_template/' + template.id, { template })
}

async function deleteScheduleTemplate(id) {
    return await instance.delete('/schedule_template/' + id, {})
}

export {
    getAllScheduleTemplates,
    updateScheduleTemplate,
    insertScheduleTemplate,
    deleteScheduleTemplate,
}
